import {
  DashboardIcon,
  PeopleIcon,
  CalendarIcon,
} from '@myjobglasses/dsm';
import { signout } from '../../../../../actions/signout';
import Routes from '../../../../../routes';
import { t } from '../../../../../utils/translate';
import { isAmbassador } from '../../../../../utils/user';
import { HeaderConfigItem } from '../../@types/HeaderConfig';
import MainMenuItem from '../../components/main-menu-item/MainMenuItem';
import UsernavItem from '../../components/usernav-item/UsernavItem';
import translations from './mjgAdmin.translations';

const config: { main: HeaderConfigItem[], connected: HeaderConfigItem[] } = {
  main: [
    {
      key: 'dashboard',
      component: MainMenuItem,
      type: 'company-link',
      className: 'main-menu-item-link-white',
      to: Routes.mjgAdminCompaniesDashboard,
      icon: DashboardIcon,
      label: t(translations.dashboard),
    },
    {
      key: 'employees',
      component: MainMenuItem,
      type: 'company-link',
      className: 'main-menu-item-link-white',
      to: Routes.mjgAdminCompaniesShow,
      icon: PeopleIcon,
      label: t(translations.ambassador),
    },
    {
      key: 'appointments',
      component: MainMenuItem,
      type: 'company-link',
      className: 'main-menu-item-link-white',
      to: Routes.mjgAdminCompaniesAppointmentsWithId,
      icon: CalendarIcon,
      label: t(translations.appointments),
    },
  ],
  connected: [
    {
      key: 'mjg-admin',
      component: UsernavItem,
      type: 'external-link',
      to: Routes.mjgAdminOnChronos,
      label: t(translations.mjgChronos),
    },
    {
      component: UsernavItem,
      type: 'company-link',
      key: 'configuration',
      to: Routes.mjgAdminCompaniesConfiguration,
      label: t(translations.configuration),
    },
    {
      component: UsernavItem,
      type: 'action',
      key: 'logout',
      onClick: (dispatch) => { dispatch(signout(Routes.home)); },
      label: t(translations.logout),
    },
    {
      component: UsernavItem,
      type: 'switch-account',
      key: 'switch-account',
      to: Routes.dashboard,
      label: t(translations.employeeMode),
      condition: ({ currentUser }) => !!currentUser && isAmbassador(currentUser),
    },
  ],
};

export default config;
